import { assign } from 'lodash';
import * as actions from '../constants';

const initialState = {
  isFetching: false,
  isLoaded: false,
  isNavigationOpen: false,
  filterVehicleType: NaN,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.REQUEST_APP_LOAD:
      return assign({}, state, {
        isFetching: true,
      });

    case actions.RECEIVE_APP_LOAD:
      return assign({}, state, {
        isFetching: false,
        isLoaded: true,
      });

    case actions.OPEN_NAVIGATION:
      return assign({}, state, {
        isNavigationOpen: true,
      });

    case actions.CLOSE_NAVIGATION:
      return assign({}, state, {
        isNavigationOpen: false,
      });

    case actions.UPDATE_VEHICLE_TYPE_FILTER:
      return assign({}, state, {
        filterVehicleType: action.filterVehicleType,
      });

    default:
      return state;
  }
};
